const InitialState = {
	machineID: "",
	location: "",
	activeRole: "",
	timezone: ""
};

export const landing = (state = InitialState, action) => {
	switch (action.type) {
		case "SET_MACHINE_ID":
			return {
				...state,
				machineID: action.data._id,
				location: action.data.locationName,
				timezone: action.data.timeZone
			};

		case "SET_ACTIVE_ROLE" :
			return {
				...state,
				activeRole: action.data
			}

		default:
			return {
				...state,
			};
	}
};

export default landing;
